import React from "react";

export default function Footer() {
	return (
		<footer>
			<p>
				Made with ❤ by{" "}
				<a target='_blanck' href='https://github.com/subhadip-kundu'>
					Subhadip Kundu
				</a>
			</p>
		</footer>
	);
}
